import Vue from "vue"
import Animation from "@/features/animate/animation.vue"

const elements = document.querySelectorAll("[data-animate]")

elements.forEach((el) => {
  const { animate: id } = el.dataset

  new Vue({
    name: "AnimateInit",
    el,
    render: (h) => h(Animation, { props: { id } })
  })
})
